export default __webpack_public_path__ + "static/media/LAS0780.34I-37189_-22003_0.333e4be1.jpg";